import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[appOnlyNumber]',
    standalone: false

})
export class OnlyNumberDirective {

    constructor(private el: ElementRef) { }

    @Input() AllowNegative: boolean;
    @Input() AllowDecimal: boolean;

    @HostListener('keydown', ['$event']) onKeyDown(event) {
        const e = event as KeyboardEvent;
        const val = event.target.value as string;
        if ([46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+C
            (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+V
            // (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+X
            (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
            // Allow a dash if it is first character
            (e.keyCode === 173 && val == '' && this.AllowNegative) ||
            // Allow one period if it is not the first character
            (e.keyCode === 190 && !val.includes('.') && val != '' && val != '-' && this.AllowDecimal) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }

        if (e.keyCode === 173 && !val.includes('-') && this.AllowNegative) {
            e.preventDefault();
            event.target.value = '-' + event.target.value;
            return;
        }

        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    }
}
